'use client'

import { useMarketBalance } from '@/hooks/wallets/use-market-balance'
import { useMarketTokenBalance } from '@/hooks/wallets/use-market-token-balance'

export function useSolanaUsdcBalance() {
	const query = useMarketBalance('kalshi')
	const cash = query.balance?.cash

	return {
		...query,
		data: cash ? { balance: Number(cash.raw), formatted: cash.formatted } : undefined,
	}
}

export function useSolanaTokenBalance(mint: string | undefined) {
	const query = useMarketTokenBalance({
		platform: 'kalshi',
		tokenAddress: mint,
		decimals: 6,
	})

	const token = query.data
	return {
		...query,
		data: token ? { balance: Number(token.raw), formatted: token.formatted } : undefined,
	}
}
